import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl';
import { Polygon } from 'geojson';
import mask from '@turf/mask';
import { COLOR_NEUTRAL_BLACK, COLOR_NEUTRAL_WHITE } from '@alltrails/denali/tokens';
import useMap from '../../hooks/useMap';
import { getLayerBeforeId, isochroneFillId, isochroneOutlineId } from '../../utils/layers';

type IsochroneProps = {
  polygon: Polygon;
};

const Isochrone = ({ polygon }: IsochroneProps) => {
  const map = useMap();
  const sourceId = 'isochrone-source';

  const maskedPolygon = useMemo(() => {
    return mask(polygon);
  }, [polygon]);

  return (
    <Source id={sourceId} type="geojson" data={maskedPolygon}>
      <Layer
        beforeId={getLayerBeforeId(map, isochroneFillId)}
        id={isochroneFillId}
        source={sourceId}
        type="fill"
        paint={{
          'fill-color': COLOR_NEUTRAL_BLACK,
          'fill-opacity': 0.4
        }}
      />
      <Layer
        beforeId={getLayerBeforeId(map, isochroneOutlineId)}
        id={isochroneOutlineId}
        source={sourceId}
        type="line"
        paint={{
          'line-color': COLOR_NEUTRAL_WHITE,
          'line-width': 2
        }}
      />
    </Source>
  );
};

export default Isochrone;
